<template>
  <span
    v-if="selectedVersion.status === TENDER_OFFER_VERSION_STATUSSES.draft"
    class="draft-flag ml-4"
  >
    <Badge color="grey">{{
      tenderOfferVersionStatuses[TENDER_OFFER_VERSION_STATUSSES.draft]
    }}</Badge>
  </span>
  <span
    v-else-if="selectedVersion.status === TENDER_OFFER_VERSION_STATUSSES.old"
    class="draft-flag ml-4"
  >
    <TenderOfferVersionOldBadge />
  </span>
  <span
    v-else-if="selectedVersion.status === TENDER_OFFER_VERSION_STATUSSES.submitted"
    class="draft-flag ml-4"
  >
    <Badge color="light-blue">{{
      tenderOfferVersionStatuses[TENDER_OFFER_VERSION_STATUSSES.submitted]
    }}</Badge>
  </span>
  <span
    v-else-if="selectedVersion.status === TENDER_OFFER_VERSION_STATUSSES.archived"
    class="draft-flag ml-4"
  >
    <Badge color="light-red">{{
      tenderOfferVersionStatuses[TENDER_OFFER_VERSION_STATUSSES.archived]
    }}</Badge>
  </span>
</template>

<script>
  import Badge from '@/components/ui/Badge';
  import TenderOfferVersionOldBadge from '@/components/tenders/tender-offer-version-badges/TenderOfferVersionOldBadge';
  import { mapState } from 'vuex';
  import TENDER_OFFER_VERSION_STATUSSES from '@/utils/constants/tender-offer-version-statuses';

  export default {
    name: 'VersionSelectorBadges',
    components: { Badge, TenderOfferVersionOldBadge },
    props: {
      selectedVersion: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapState('global', ['tenderOfferVersionStatuses']),
    },
    data() {
      return {
        TENDER_OFFER_VERSION_STATUSSES,
      };
    },
  };
</script>
